import React, { Component } from "react";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import Container from "../Container/Container";
import "./Surveys.scss";
import SurveyRequest from "../../request/SurveyRequest";
import Concepts from "./Concepts";
import XmlNodeStringFormat from "./XmlNodeStringFormat";
import XMLParser from "react-xml-parser";
import ColorHelper from "../../helper/ColorHelper";
import { Button } from "global-components-library";
import { setCloseConversation } from "../../redux/conversationDucks";
import { connect } from "react-redux";

class Surveys extends Component {
  constructor(props) {
    super(props);
    this.state = {
      jsonSurvey: null,
      questionsXml: "",
      conceptsXml: "",
      buttonColorStyle: null,
    };
  }

  componentDidMount() {
    Promise.resolve(SurveyRequest.get()).then((json) => {
      let colorHelper = ColorHelper.getInstance();
      if (!json.attributes.description) {
        this.props.onRestoreStates();
      }
      this.setState({
        jsonSurvey: json,
        buttonColorStyle: colorHelper.getButtonColorStyle(),
      });
    });
  }

  onQuestionAnswered = (xmlString) => {
    this.setState({ questionsXml: xmlString });
  };

  onConceptRendered = (xmlString) => {
    this.setState({ conceptsXml: xmlString });
  };

  getConceptsXml = () => {
    const { conceptsXml, questionsXml } = this.state;
    let conceptEnd = XmlNodeStringFormat.ConceptNodeEnd();
    return conceptsXml + " " + questionsXml + " " + conceptEnd;
  };

  getTotal = (conceptXml) => {
    var jsonConcept = new XMLParser().parseFromString(conceptXml);
    let total = 0;
    jsonConcept.children.map((x) => {
      total += parseInt(x.attributes.answerWeight);
    });
    return total;
  };

  onSubmit = () => {
    const { id, version } = this.state.jsonSurvey.attributes;

    let formatEnd = XmlNodeStringFormat.FormatNodeEnd();
    let conceptXml = this.getConceptsXml();

    let xmlString = XmlNodeStringFormat.FormatNodeStart(
      id,
      version,
      this.props.agentId,
      this.getTotal(conceptXml)
    );
    xmlString += " " + conceptXml + " " + formatEnd;
    SurveyRequest.fakePostSurvey(xmlString);
    this.props.onRestoreStates();
    this.props.closeConversation();
  };

  render() {
    const { jsonSurvey, buttonColorStyle } = this.state;
    let { surveys } = window["labels"];
    return (
      <div className="survey-container">
        <Header minimize={this.props.minimize} />
        <Container>
          {jsonSurvey && (
            <div className="survey-body">
              <span>{jsonSurvey.attributes.description}</span>
              <Concepts
                concepts={jsonSurvey.children}
                onQuestionAnswered={this.onQuestionAnswered}
                onConceptRendered={this.onConceptRendered}
              />
              <div className="survey-container-btn-send">
              <Button color='primary' onClick={this.onSubmit}>{surveys.btn}</Button>
              </div>
            </div>
          )}
        </Container>
        <Footer />
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return ({
    closeConversation: () => { dispatch(setCloseConversation());},
  });
}

export default Surveys = connect(
  null,
  mapDispatchToProps
)(Surveys);